import { motion } from "framer-motion";
import { ArrowRight, Check, ShieldCheck, Smartphone } from "lucide-react";
import { CHECKOUT_URL, OLD_PRICE, PRICE } from "@/constants/checkout";
import { Eyebrow, Reveal } from "./Reveal";

const included = [
  "E-book completo com 11 capítulos diretos ao ponto",
  "Um exercício prático ao final de cada capítulo",
  "Checklists para montar o prato e o cardápio da semana",
  "O método dos 5 passos: do zero à constância",
  "Guia dos erros que custam caro (e como evitá-los)",
  "Acesso vitalício em PDF, no celular ou computador",
];

export default function Offer() {
  return (
    <section id="oferta" data-testid="offer-section" className="bg-sand/60 py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <div className="relative overflow-hidden rounded-[2.5rem] bg-forest px-6 py-14 text-cream shadow-[0_40px_80px_-30px_rgba(44,74,62,0.6)] sm:px-12 lg:px-16">
            <div className="pointer-events-none absolute -right-20 -top-20 h-72 w-72 rounded-full bg-ochre/20 blur-3xl" />
            <div className="pointer-events-none absolute -bottom-24 -left-16 h-72 w-72 rounded-full bg-terracotta/25 blur-3xl" />

            <div className="relative grid items-center gap-12 lg:grid-cols-2">
              <div>
                <Eyebrow className="text-ochre">Oferta de lançamento</Eyebrow>
                <h2 className="mt-4 font-serif text-3xl font-semibold leading-tight tracking-tight sm:text-4xl">
                  Tudo o que você recebe{" "}
                  <span className="italic text-ochre">hoje</span>
                </h2>
                <ul className="mt-8 space-y-3.5">
                  {included.map((item, i) => (
                    <li key={item} data-testid={`offer-item-${i + 1}`} className="flex items-start gap-3 text-sm leading-relaxed text-cream/85 sm:text-base">
                      <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-ochre/20 text-ochre">
                        <Check size={14} strokeWidth={3} />
                      </span>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>

              <div className="relative rounded-3xl bg-cream p-8 text-ink shadow-2xl sm:p-10">
                <motion.img
                  src="/assets/selo-garantia.png"
                  alt="Selo Compra Garantida — 7 dias, 100% seguro"
                  data-testid="guarantee-seal"
                  initial={{ opacity: 0, scale: 0.5, rotate: -20 }}
                  whileInView={{ opacity: 1, scale: 1, rotate: 6 }}
                  viewport={{ once: true }}
                  transition={{ type: "spring", stiffness: 180, damping: 14, delay: 0.4 }}
                  className="absolute -right-4 -top-9 w-24 drop-shadow-xl sm:-right-8 sm:w-28"
                />
                <p className="text-xs font-bold uppercase tracking-[0.25em] text-terracotta">
                  Nutrição Zero ao Equilíbrio
                </p>
                <div className="mt-5 flex items-end gap-3">
                  <span className="pb-2 text-sm text-moss line-through">De R$ {OLD_PRICE}</span>
                </div>
                <p data-testid="offer-price" className="font-serif text-6xl font-bold leading-none tracking-tight sm:text-7xl">
                  <span className="align-top text-2xl">R$</span> {PRICE}
                </p>
                <p className="mt-2 text-sm font-medium text-moss">Pagamento único • acesso imediato e vitalício</p>

                <a
                  href={CHECKOUT_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="checkout-button-offer"
                  className="cta-shine mt-8 flex w-full items-center justify-center gap-2 rounded-full bg-terracotta px-8 py-4 text-center text-base font-bold text-cream shadow-[0_18px_40px_-12px_rgba(200,109,81,0.55)] transition-transform duration-300 hover:-translate-y-1"
                >
                  Garantir meu e-book agora <ArrowRight size={18} />
                </a>

                <div className="mt-6 flex items-start gap-2.5 rounded-2xl bg-mint p-4">
                  <ShieldCheck size={20} className="mt-0.5 shrink-0 text-forest" />
                  <p className="text-xs leading-relaxed text-forest sm:text-sm">
                    <strong>Garantia incondicional de 7 dias.</strong> Se não for para você,
                    devolvemos 100% do valor. Sem perguntas.
                  </p>
                </div>

                <p className="mt-5 flex items-center justify-center gap-2 text-center text-xs font-medium text-moss">
                  <Smartphone size={14} /> Pix • Cartão • Boleto — checkout seguro via Monetizze
                </p>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
